<section class="unauthorized-container">
  <section class="unauthorized-container__section">
    <div class="unauthorized-container__img-container">
      <svg-icon class="unauthorized-container__img"
                src="assets/icons/unauthorized.svg"></svg-icon>
    </div>

    <div class="unauthorized-container__section-title"
         [translate]="'unauthorized.top-title'"></div>

    <div class="unauthorized-container__section-desc"
         [translate]="'unauthorized.desc-top'"></div>

    <div class="unauthorized-container__section-desc"
         [translate]="'unauthorized.desc-bottom'"></div>

    <a class="unauthorized-container__section-link" routerLink="/"
       [translate]="'unauthorized.link-text'">
    </a>
  </section>
</section>
